import { ARTICLES } from './catalog.data.js';
export { ARTICLES };
/** Only what can go in a fridge or pantry. */
export const EDIBLE_ARTICLES = ARTICLES.filter((a) => a.edible);
/**
 * Fold to a comparable form: lower case, no diacritics, ß as ss.
 *
 * Without this, typing "apfel" misses "Äpfel" and "musli" misses "Müsli" —
 * which is exactly what someone types on a panel keyboard when they cannot be
 * bothered to reach for the umlaut.
 */
export function foldGerman(value) {
    return value
        .toLowerCase()
        .replace(/ß/g, 'ss')
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '');
}
/**
 * Autocomplete over the catalogue.
 *
 * Ranked, not merely filtered: a prefix match is what the typist meant, a
 * word-start match is usually right, and a mid-word match is a long shot.
 * Sorting by that beats alphabetical, which would put "Apfelmus" above "Apfel".
 */
export function searchArticles(query, { limit = 8, edibleOnly = true } = {}) {
    const q = foldGerman(query.trim());
    if (q.length === 0)
        return [];
    const pool = edibleOnly ? EDIBLE_ARTICLES : ARTICLES;
    const hits = [];
    for (const article of pool) {
        const folded = foldGerman(article.name);
        let rank;
        if (folded.startsWith(q))
            rank = 0;
        else if (folded.includes(` ${q}`))
            rank = 1;
        else if (folded.includes(q))
            rank = 2;
        else
            continue;
        hits.push({ article, rank });
    }
    return hits
        .sort((a, b) => a.rank - b.rank ||
        // Shorter is the more general word: "Apfel" before "Apfelsaft".
        a.article.name.length - b.article.name.length ||
        a.article.name.localeCompare(b.article.name, 'de'))
        .slice(0, limit)
        .map((h) => h.article);
}
/**
 * The catalogue's keeping time for an exact name, if it knows one.
 *
 * Named apart from expiry.ts's shelfDaysFor, which answers a different
 * question — how long an item that already exists was given.
 */
export function catalogShelfDays(name) {
    const folded = foldGerman(name.trim());
    return ARTICLES.find((a) => foldGerman(a.name) === folded)?.shelfDays ?? null;
}
